import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Feeds } from 'src/app/models/feeds';
import { LoginResponseVo } from 'src/app/models/loginresponsevo';
import { LoginVo } from 'src/app/models/loginVo';
import { WebService } from 'src/app/service/web.service';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss']
})
export class LoginPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LoginPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private http: HttpClient, private router:Router, private webService : WebService,
  ) { }

  // For login
  userName: any = '';
  password: any = '';
  userNameReq: boolean = false;
  passReq: boolean = false;

  isLogin: boolean = true;

  // For sign up
  signInfo: SigninInfo = new SigninInfo();
  signNameReq: boolean = false;
  lastNameReq: boolean = false;
  emailReq: boolean = false;
  birthDateReq: boolean = false;
  signPasswordReq: boolean = false;
  emailAlreadyExists: boolean = false;
  cnfPasswordReq: boolean = false;
  cnfPasswordmatch: boolean = false;
  cnfPasswordInvalid: boolean = false;

  
  ngOnInit(): void {
  }

   login() {
     this.validateLogin();
    if(this.userNameReq || this.passReq) {
      return;
    }

    let loginvo = new LoginVo();
    loginvo.email = this.userName;
    loginvo.password = this.password;

   

    this.loginCall(loginvo)
    .subscribe(data => {
          let responce : any = data;
          if(responce.Items != undefined && responce.Items.length>0){

               localStorage.setItem("isAuthenticated","true");
               localStorage.setItem("userId",responce.Items[0].id);
               localStorage.setItem("userName",responce.Items[0].firstName + " "+ responce.Items[0].lastName);
               localStorage.setItem("userType",responce.Items[0].userType);
               
              //  this.router.navigateByUrl("feeds");
              this.dialogRef.close();
          } else {
            this.cnfPasswordInvalid = true
          } 
          
    });

    
  }

  loginCall(loginvo:any) {
    return this.http.post("https://7cncmrvqpnbndvjkqrqoewlguu0kgota.lambda-url.us-west-1.on.aws/",loginvo);
  }

  validateLogin() {
    if(!this.validateText(this.userName)) {
      this.userNameReq = true;
    }
    if(!this.validateText(this.password)) {
      this.passReq = true;
    }
  }

  handleUsName(event: any) {
    this.cnfPasswordInvalid = false;

    if(this.validateText(this.userName)) {
      this.userNameReq = false;
      return;
    }
    this.userNameReq = true;
  }

  handlePass(event: any) {
    this.cnfPasswordInvalid = false;

    if(this.validateText(this.password)) {
      this.passReq = false;
      return;
    }
    this.passReq = true;
  }

  removeLogin() {
    this.userName = '';
    this.password = '';
    this.userNameReq = false;
    this.passReq = false;
  }

  switchLogin(data: boolean) {
    if(this.isLogin && !data) {
      this.removeLogin();
    } else if(!this.isLogin && data) {
      this.removeSignUp();
    }
    this.isLogin = data;
  }

  async signUp() {
    if(await this.validateSignUp()) {
      let adduserVo  :any = {};
   adduserVo.firstName = this.signInfo.firstName;
   adduserVo.lastName = this.signInfo.lastName;
   adduserVo.email =  this.signInfo.email;
   adduserVo.birthDate =  this.signInfo.birthDate;
   adduserVo.password = this.signInfo.signPassword;

   this.webService.checkUserxists(adduserVo.email).subscribe((data1:any)=>{

        if(data1){
          this.emailAlreadyExists = true;
              this.focusDiv("sgn-email");
        } else {
          this.webService.addUser(adduserVo).subscribe((data:any)=>{

            let responce : any = data;
          if(responce.Item != undefined && responce.Item){

               localStorage.setItem("isAuthenticated","true");
               localStorage.setItem("userId",responce.Item.id);
               localStorage.setItem("userName",responce.Item.firstName + " "+ responce.Item.lastName);
               localStorage.setItem("userType",responce.Item.userType);
               
              //  this.router.navigateByUrl("feeds");
              this.dialogRef.close();
          } else {
            this.cnfPasswordInvalid = true
          } 
        })
        }

  })
    } 
  }

  async  validateSignUp() {
    let isValidSign: boolean = true;
    let isFocused: boolean = false;
    if(!this.validateText(this.signInfo.firstName)) {
      this.signNameReq = true;
      isValidSign = false;
      this.focusDiv("sgn-name");
      isFocused = true;
    }
    if(!this.validateText(this.signInfo.lastName)) {
      this.lastNameReq = true;
      isValidSign = false;
      if(!isFocused) {
        this.focusDiv("lst-name");
        isFocused = true;
      }
    }
    if(!this.validateText(this.signInfo.birthDate)) {
      this.birthDateReq = true;
      isValidSign = false;
      if(!isFocused) {
        this.focusDiv("sgn-dob");
        isFocused = true;
      }
    } else {
      this.birthDateReq = false;
    }
    if(!this.validateText(this.signInfo.email)) {
      this.emailReq = true;
      isValidSign = false;
      if(!isFocused) {
        this.focusDiv("sgn-email");
        isFocused = true;
      }
    }
    if(!this.validateText(this.signInfo.signPassword)) {
      this.signPasswordReq = true;
      isValidSign = false;
      if(!isFocused) {
        this.focusDiv("sgn-pwd");
        isFocused = true;
      }
    }
    if(!this.validateText(this.signInfo.cnfPassword)) {
      this.cnfPasswordReq = true;
      isValidSign = false;
      if(!isFocused) {
        this.focusDiv("sgn-cnf");
        isFocused = true;
      }
    }

    if(this.validateText(this.signInfo.cnfPassword)  &&  this.validateText(this.signInfo.signPassword)) {

      if(this.signInfo.signPassword != this.signInfo.cnfPassword) {
        this.cnfPasswordmatch = true;
        isValidSign = false;
          if(!isFocused) {
           this.focusDiv("sgn-cnf");
            isFocused = true;
           }
       }
    }
    return isValidSign;
  }


  async checkUser(email:any) : Promise<any> {

    this.webService.checkUserxists(email).subscribe((data:any)=>{
        return data;
    })
    
  }

  focusDiv(id: string) {
    let errDiv = document.getElementById(id);
    if(errDiv) {
      errDiv.focus();
    }
  }

  handleSignName(event: any) {
    if(this.validateText(this.signInfo.firstName)) {
      this.signNameReq = false;
      return;
    }
    this.signNameReq = true;
  }

  handleLastName(event: any) {
    if(this.validateText(this.signInfo.lastName)) {
      this.lastNameReq = false;
      return;
    }
    this.lastNameReq = true;
  }

  handleEmail(event: any) {
    this.emailAlreadyExists=false;
    if(this.validateText(this.signInfo.email)) {
      this.emailReq = false;
      return;
    }
    this.emailReq = true;
  }

  handleDOB(event: any) {
    if(this.validateText(this.signInfo.birthDate)) {
      this.birthDateReq = false;
      return;
    }
    this.birthDateReq = true;
  }

  handleSignPass(event: any) {
    if(this.validateText(this.signInfo.signPassword)) {
      this.signPasswordReq = false;
      return;
    }
    this.signPasswordReq = true;
  }

  handleSignConfPass(event: any) {
    this.cnfPasswordmatch=false;
    if(this.validateText(this.signInfo.cnfPassword)) {
      this.cnfPasswordReq = false;
      return;
    }
    this.cnfPasswordReq = true;
  }

  removeSignUp() {
    this.signInfo = new SigninInfo();
    this.signNameReq = false;
    this.lastNameReq = false;
    this.emailReq = false;
    this.emailAlreadyExists=false;
    this.birthDateReq = false;
    this.signPasswordReq = false;
    this.cnfPasswordReq = false;
    this.cnfPasswordInvalid = false;
  }

  validateText(text: string): boolean {
    if (text == undefined || text == null ||
      text == ""  || text.trim().length === 0 ) {
      return false;
    }
    return true;
  }

  closePop(event: any, data: any) {
    this.dialogRef.close();
  }

  forgetPassword() {
    this.dialogRef.close('Custom_Forgot_Password');
  }

}

interface DialogData {
  
}

export class SigninInfo {
  firstName: any = '';
  lastName: any = '';
  email: any = '';
  birthDate: any = '';
  signPassword: any = '';
  cnfPassword: any = '';
}
